<template>
  <div class="section-main__warp person-mg_person_identify">
    <div class="left-tab-list flex-valign"
         v-loading="listLoading"
         element-loading-text="加载中..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="detail-title leftList-title map-blur-panel__title">
        <div class="list-search_form">
          <el-form label-width="10px">
            <div style="display: flex">
              <el-button @click="
                  areaLeft = true;
                  showTree();
                "
                         type="text">选择区域</el-button>
              <el-form-item style="margin-top: 20px; margin-left: 10px">
                <div @click.stop="statusExpandType = !statusExpandType"
                     class="flex-center valign-center">
                  <div class="mr5 ell flex-auto">
                    <span v-if="isSpan">{{ IdentifyType(typeValue) }}</span>
                    <span v-else>识别类型</span>
                  </div>
                  <span :class="[
                      'iconfont-lunan icon-lunan-xiaosanjiaodown',
                      statusExpandType ? 'icon-transform' : '',
                      'select-arrow',
                    ]"></span>
                </div>
                <div :class="['type-select', statusExpandType ? 'expand' : '']">
                  <el-scrollbar class="select-area flex-valign">
                    <div class="type-option flex-auto valign-center"
                         v-for="(item, index) in types"
                         :key="index"
                         @click.stop="
                        chooseType(index, 'status', 'statusExpandType')
                      ">
                      {{ item.label }}
                    </div>
                  </el-scrollbar>
                </div>
              </el-form-item>
            </div>

            <el-form-item>
              <el-input v-model="deviceName"
                        style="margin-left: -10px"
                        placeholder="请输入设备名称"
                        clearable>
                <el-button slot="append"
                           icon="el-icon-search "
                           @click="queryMatchRecord"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="box-card flex-auto">
        <el-scrollbar class="scroll-content"
                      style="height: calc(100% - 30px)"
                      ref="matchList">
          <IdentifyList ref="IdentifyList"
                        customClass="column"
                        :show-track="true"
                        :data="strangerList"
                        @listDetailCilck="viewDetail"
                        @showTrajectory="showTrajectory"
                        @viewDetail="viewDetail"></IdentifyList>
        </el-scrollbar>
        <div class="map-blur-panel__title"
             v-auth="'/access/identifyCenter:query'"
             style="text-align: right; line-height: 30px; padding-right: 20px">
          <el-button @click="showAll"
                     type="text">查看全部</el-button>
        </div>
      </div>
    </div>
    <!-- 右侧侧边栏 人员&车辆 -->
    <div :class="'vehicle-to ' + (visibleRight ? 'expand' : 'collspand')">
      <div class="blur-bg map-blur-panel"></div>
      <div style="position: relative">
        <person-search v-show="main && nowMatchType === 1"
                       ref="personSearch"
                       @searchArea="searchArea"
                       @personData="getPersonData"></person-search>
        <track-info ref="trackInfo"
                    v-show="!main && nowMatchType === 1"></track-info>
        <car-search ref="carSearch"
                    v-show="main && nowMatchType === 2"
                    @carData="getCarData"></car-search>
        <car-info ref="carInfo"
                  v-show="!main && nowMatchType === 2"></car-info>
      </div>
      <!-- 右侧收缩按钮(如果当前是展示识别详情，则不展示缩进按钮) -->
      <div v-if="!visibleDetail"
           :class="
          'map-blur-panel__expand-button right ' +
          (visibleRight ? 'expand' : 'collspand')
        "
           @click="handleVisible">
        <i class="iconfont-lunan icon-lunan-shousuocaidan"
           v-if="!visibleRight"></i>
        <i class="iconfont-lunan icon-lunan-shousuocaidan-copy"
           v-if="visibleRight"></i>
      </div>
    </div>
    <!-- 右侧侧边栏 人员&车辆详情 -->
    <div :class="'vehicle-detail ' + (visibleDetail ? 'expand' : 'collspand')">
      <div class="blur-bg map-blur-panel"></div>
      <div style="position: relative; overflow: auto; height: 83vh">
        <div class="main-title">
          <span> {{ nowMatchType === 1 ? "人员" : "车辆" }}详情</span>
          <div class="close-btn"
               @click="handleClose">
            <i class="iconfont-lunan icon-lunan-ziyuanldpi"
               style="font-size: 12px"></i>
          </div>
        </div>
        <!-- <div class="sub-title">
         信息
        </div> -->
        <div class="info-area">
          <el-form ref="form"
                   :model="detailInfo"
                   label-width="90px">
            <el-form-item class="item-margin"
                          label=""
                          label-width="0px">
              <img class="stranger_img"
                   :src="getImageUrl(detailInfo.fileCode)"
                   @click="showViewer"
                   style="width: 60%; height: 130px; margin: 0 20%"
                   onerror="this.src='/images/theme/newDark/default.png'" />
            </el-form-item>
            <el-row class="">
              <el-col :span="12">
                <el-form-item class="item-margin"
                              :label="nowMatchType === 1 ? '姓名：' : '车主姓名：'">
                  <el-input v-if="isMark && isNeedEdit"
                            v-model="markData.personName"></el-input>
                  <label v-else>{{
                    (detailInfo.personnel && detailInfo.personnel.name) ||
                    detailInfo.personName ||
                    "陌生人"
                  }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="item-margin"
                              label="性别："
                              v-if="isMark && isNeedEdit">
                  <el-select v-model="markData.sex"
                             placeholder="请选择">
                    <el-option v-for="item in sexOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="item-margin"
                              label="性别："
                              v-else>
                  <label v-if="detailInfo.personnel !== null">{{
                    (detailInfo.personnel && detailInfo.personnel.sex)
                      | showSexType
                  }}</label>
                  <label v-else>{{ detailInfo.sex | showSexType }}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item class="item-margin"
                              label="电话：">
                  <el-input v-if="isMark && isNeedEdit"
                            v-model="markData.phone"></el-input>
                  <label v-else>{{
                    (detailInfo.personnel && detailInfo.personnel.phone) ||
                    detailInfo.phone ||
                    "未知"
                  }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="item-margin"
                              label="身份证：">
                  <el-input v-if="isMark && isNeedEdit"
                            v-model="markData.idCard"></el-input>
                  <label v-else>{{
                    (detailInfo.personnel && detailInfo.personnel.idCard) ||
                    detailInfo.idCard ||
                    "未知"
                  }}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item class="item-margin"
                              v-if="nowMatchType === 2"
                              label="车牌：">
                  <label>{{ detailInfo.plateNo }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="item-margin"
                              :label="nowMatchType === 1 ? '类型：' : '车主类型：'">
                  <label>{{
                    detailInfo.personnelType == 1
                      ? "员工"
                      : detailInfo.personnelType == 2
                      ? "外来人员"
                      : "陌生人"
                  }}</label>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="item-margin"
                          label="位置：">
              <label>{{ detailInfo.areaName || "未知" }}</label>
            </el-form-item>
            <el-form-item class="item-margin"
                          label="时间：">
              <label>{{ detailInfo.matchTime || "-" }}</label>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="!isMark"
             class="mark-btn"
             v-auth="'/access/identifyCenter:mark'">
          <el-button type="primary"
                     @click="clickMarkBtn">标 记</el-button>
        </div>
        <div class="sub-title"
             v-if="isMark">类型标记</div>
        <div class="info-area"
             v-if="isMark">
          <remark-handle ref="remarkHandle"
                         :markData="markData"
                         :detailInfo="detailInfo"
                         :matchRecordCode="detailInfo.matchRecordCode"
                         :match-type="nowMatchType"
                         @cancleMark="cancleMark"
                         @showTree="showTree"
                         @assignTask="assignTask"
                         @searchArea="searchArea2"
                         @recordMarked="recordMarkedHandle"></remark-handle>
        </div>
      </div>
    </div>
    <!-- 地图轨迹详情 -->
    <track-detail v-if="showTrack"
                  :data="trackData"
                  ref="trackDetail"></track-detail>
    <app-camers-group ref="areaTree"
                      :isRequired="false"
                      @saveChecked="changeCamersGroup" />
    <assignDialog onlyHandAlarm
                  ref="taskAssign"
                  @childByValue="childByValue"></assignDialog>
    <viewer @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer">
      <img v-for="src in viewerPhotos"
           :src="src"
           :key="src" />
    </viewer>
  </div>
</template>

<script>
import appCamersGroup from "@src/components/business/app-area-tree";
import personSearch from "../components/person-search";
import carSearch from "../components/car-search";
import trackInfo from "../components/track-info";
import carInfo from "../components/car-info";
import remarkHandle from "../components/remark-handle";
import IdentifyList from "../components/IdentifyList";
import trackDetail from "@src/components/business/app-track-detail/track-detail.vue";
import assignDialog from "@src/modules/taskCenter/components/TaskAssignComponent";
import { api } from "../api";
import { Dic, Dates, Bus } from "$utils";
import { mapState } from "vuex";

export default {
  components: {
    appCamersGroup,
    personSearch,
    carSearch,
    IdentifyList,
    trackDetail,
    trackInfo,
    carInfo,
    remarkHandle,
    assignDialog,
  },
  filters: {
    formartterTime (time) {
      return time
        ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    showSexType (sex, item) {
      if (sex === null) {
        return "未知";
      } else if (Number(sex) === 0) {
        return "女";
      } else if (Number(sex) === 1) {
        return "男";
      }
      // return Dic.findByValue('SENU001', Number(sex))
    },
  },
  beforeRouteLeave: (to, from, next) => {
    next((vm) => {
      vm.$app.clearAlarm();
    });
  },

  data () {
    return {
      listLoading: false,
      statusExpandType: false,
      showTreeList: false,
      visibleRight: this.$route.query.visibleRight
        ? this.$route.query.visibleRight
        : false,
      visibleDetail: this.$route.query.visibleDetail
        ? this.$route.query.visibleDetail
        : false,
      fileId: "",
      main: true,
      nowPersonInfo: "", // 当前人员的信息
      personDataList: [],
      isPeopleShow: false,
      moreList: [],
      isSpan: false,
      types: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "陌生人员",
          value: 1,
        },
        {
          label: "陌生车辆",
          value: 2,
        },
      ],
      trackData: {},
      typeValue: "",
      match: {
        area: [],
        areaName: "",
      },
      strangerList: [],
      nowMatchType: 1,
      areaLeft: false,
      pageNum: 1,
      pageSize: 10,
      areasList: {
        area: [],
        areaName: [],
      },
      showTrack: false,
      detailInfo: {},
      viewerPhotos: [],
      recordMarked: false,
      isMark: false,
      isNeedEdit: false,
      markData: {},
      layerId: "MAP_IDENTIFY",
      sexOptions: Dic.find("SENU001"),
      deviceName: "",
      searchFormShow: false,
    };
  },
  watch: {
    strangersList (newVal) {
      console.log("识别推送", newVal);
      this.strangerList = [newVal].concat(this.strangerList);
    },
    identifyAlarmList (newVal) {
      this.queryMatchRecord();
    },
  },
  computed: {
    ...mapState({
      strangersList: (state) => state.ioc.strangerList,
      alarmCount: (state) => state.ioc.alarmCount,
      identifyAlarmList: (state) => state.ioc.identifyAlarmList,
    }),
    currentTheme () {
      return this.$store.getters.currentTheme;
    },
    nameComputer () {
      return this.detailInfo.personnel
        ? this.detailInfo.personnel.name
        : this.detailInfo.personName;
    },
  },
  beforeDestroy () {
    this.$map.MapInstance2D.closeTips();
    if (this.refreshSecurityTimer) {
      clearInterval(this.refreshSecurityTimer);
    }
    this.$map.hideMap2D();
  },
  mounted () {
    this.$map.showMap2D(this.initMapResources);
    this.$map.addClickEvent((e) => {
      this.trackData = e;
      this.$refs.IdentifyList.initChildren(e);
    });
    this.queryMatchRecord();
    this.scrollbar();
    this.getAreaTree();
    this.initTrack();
    // 从识别记录页面跳转过来的
    if (this.$route.query.visibleDetail) {
      this.viewDetail(this.$route.query.val);
    }
    this.getAreaByAccount();
  },
  methods: {
    IdentifyType (type) {
      switch (type) {
        case 0:
          return "全部";
        case 1:
          return "陌生人员";
        case 2:
          return "陌生车辆";
      }
    },
    chooseType (index, label, expandType) {
      this[expandType] = false;
      this.typeValue = index;
      this.isSpan = true;
      this.queryMatchRecord();
    },
    initMapResources () {
      this.$map.MapInstance2D.initPage();
    },
    getSecurityList () {
      this.loadSecurity();
      if (this.refreshSecurityTimer) {
        clearInterval(this.refreshSecurityTimer);
      }
      this.refreshSecurityTimer = setInterval(() => {
        this.loadSecurity();
      }, 10000);
    },
    loadSecurity () {
      this.securityList = [];
      this.$fetch(api.queryLocationList).then((res) => {
        if (res.success) {
          this.securityList = (res.returnObj || []).map((item) => {
            return {
              id: item.accountNumber,
              src: `images/theme/${this.currentTheme}/map/security_green.png`,
              label: item.nickName,
              longitude: item.lng,
              latitude: item.lat,
              attr: { ...item },
              tipsTitle: "保卫详情",
              showTips: true,
              tipsMap: {
                nickName: "姓名",
              },
            };
          });
          if (this.showSecurity) {
            this.showMapLayer(this.securityList, this.securityLayerId);
          }
        } else {
          this.$log.error("查询保卫人员位置信息失败");
        }
      });
    },
    showMapLayer (points = [], layerId = "") {
      this.$map.MapInstance2D.addMarket(points, layerId);
    },
    clickMarkBtn () {
      this.isMark = true;
      if (
        (this.detailInfo.personnel &&
          this.detailInfo.personnel.name !== null) ||
        this.detailInfo.personName !== null
      ) {
        this.isNeedEdit = false;
      } else {
        this.isNeedEdit = true;
      }
    },
    recordMarkedHandle (val) {
      this.recordMarked = val;
    },
    inited (viewer) {
      this.viewerInstance = viewer;
    },
    showViewer (e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    assignTask () {
      this.$refs.taskAssign.open();
    },
    childByValue (taskAssignInfo) {
      let url = api.addTaskInfo;
      this.$fetch(url, taskAssignInfo).then((res) => {
        if (res.success) {
          // 任务下发成功：关闭下发任务弹窗、关闭右侧详情面板、刷新左侧列表页面
          this.$refs.taskAssign.close();
          // 关闭右侧详情面板同时刷新左侧列表页面
          this.cancleMark(true);
          this.$message({
            message:
              (this.isEdit
                ? this.$t("taskCenter.label.modify")
                : this.$t("taskCenter.label.add")) +
              this.$t("taskCenter.label.success"),
            type: "success",
          });
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    handleClose () {
      this.cancleMark(false);
      this.initMapResources();
      this.$map.MapInstance2D.clearLayer("MAP_IDENTIFY");
      this.$map.MapInstance2D.setMapCenter();
    },
    getImageUrl (url) {
      return url ? Bus.imgPath(url) : "";
    },
    initTrack () {
      if (this.$route.query && this.$route.query.val) {
        this.setSearch(this.$route.query.val);
      }
    },
    getAreaTree () {
      this.$fetch(api.querydeviceByArea, { type: "2" }).then((res) => { });
    },
    changeCamersGroup (data) {
      if (this.visibleDetail && !this.areaLeft) {
        // 详情标记
        this.$refs.remarkHandle.changeCamersGroup(data);
        return;
      }
      if (this.areaLeft) {
        // left 列表查询使用
        // this.matchArea = [];
        // this.matchAreaName = [];
        // data.map((val) => {
        //   this.matchArea.push(val.areaDevGroupCode);
        //   this.matchAreaName.push(val.areaDevGroupName);
        // });
        this.setCamersData(data, this.match);
        this.pageNum = 1;
        this.pageSize = 10;
        this.queryMatchRecord();
      } else if (this.nowMatchType === 1) {
        // 条件检索使用
        this.setCamersData(data, this.$refs.personSearch.formData);
      } else if (this.nowMatchType === 2) {
        // 车辆研判
        this.setCamersData(data, this.$refs.carSearch.formListData);
      }
    },
    setCamersData (data, formData) {
      formData.area = [];
      formData.areaName = "";
      let areaName = [];
      data.map((val) => {
        formData.area.push(val.areaDevGroupCode);
        areaName.push(val.areaDevGroupName);
        formData.areaName = areaName.join(",");
      });
    },
    handleVisible () {
      if (this.visibleRight || this.visibleDetail) {
        this.visibleRight = false;
        this.visibleDetail = false;
      } else {
        this.visibleRight = true;
      }
    },
    cancleMark (hasRefresh) {
      this.recordMarked = false;
      this.visibleRight = false;
      this.visibleDetail = false;
      this.showTreeList = false;
      if (hasRefresh) {
        this.pageNum = 1;
        this.pageSize = 10;
        this.queryMatchRecord();
      }
    },
    queryMatchRecord () {
      let params = {
        matchType: this.typeValue,
        areaList: this.match.area,
        startTime: "",
        endTime: "",
        isStrange: "1",
        deviceName: this.deviceName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.listLoading = true;
      this.$fetch(api.queryMatchRecordList, params).then((res) => {
        this.listLoading = false;
        if (res.success) {
          if (this.pageNum === 1) {
            this.strangerList = res.returnObj.list;
          } else {
            this.strangerList = this.strangerList.concat(res.returnObj.list);
          }
        } else {
          this.$message.error(res.msgContent);
          this.typeValue = "";
        }
        this.match.area = [];
        // this.deviceName = "";
      });
    },
    reset () {
      this.typeValue = "";
      this.match.area = [];
      this.deviceName = "";
      this.queryMatchRecord();
    },
    getAreaByAccount () {
      //获取默认区域树结构
      this.$fetch("/cms/area/queryAreaDevGroupListByAccountNumber.json").then(
        (res) => {
          if (res && res.success) {
            const areaName = [];
            let areaDevGroupList = new Array();
            areaDevGroupList = [...res.returnObj];
            areaDevGroupList.forEach((val) => {
              this.$refs.personSearch.formData.area.push(val.areaDevGroupCode);
              areaName.push(val.areaDevGroupName);
            });
            this.$refs.personSearch.formData.areaName = areaName.join(",");
          } else {
            this.$message.error("获取数据失败,请稍后再试");
          }
        }
      );
    },
    showTree () {
      this.$refs["areaTree"].openDialog(this.match.area);
      // this.showTreeList = true
    },
    searchArea () {
      this.$refs["areaTree"].openDialogDefaultChecked(
        this.$refs.personSearch.formData.area
      );
      // this.showTreeList = true
      this.areaLeft = false;
    },
    searchArea2 () {
      this.$refs["areaTree"].openDialog(
        this.$refs.remarkHandle.markForm.areaList
      );
      // this.showTreeList = true
      this.areaLeft = false;
    },
    scrollbar () {
      this.matchList = this.$refs.matchList;
      this.boxScrollContainer = this.matchList.$el.querySelector(
        ".el-scrollbar__wrap"
      );
      this.scrollView = this.boxScrollContainer.querySelector(
        ".el-scrollbar__view"
      );
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
          this.scrollView.clientHeight &&
          !this.isLoading
        ) {
          this.pageNum = this.pageNum + 1;
          this.queryMatchRecord();
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    listDetailCilck (item) {
      this.$map.MapInstance2D.clearLayer(this.layerId);
      let flickerDrawPoint = [];
      this.nowMatchType = item.matchType;
      let _self = this;
      flickerDrawPoint.push({
        id: item.deviceId,
        src: `images/theme/${this.currentTheme}/map/state/4_1.png`,
        srcMap: [
          `images/theme/${this.currentTheme}/map/state/4_1.png`,
          `images/theme/${this.currentTheme}/map/state/4_2.png`,
          `images/theme/${this.currentTheme}/map/state/4_3.png`,
          `images/theme/${this.currentTheme}/map/state/4_4.png`,
        ],
        label: item.deviceName,
        coord: [item.longitude, item.latitude],
        imgIndex: 0,
        attr: {
          imgIndex: 0,
          label: item.deviceName,
          src: `images/theme/${this.currentTheme}/map/state/4_1.png`,
          id: item.deviceId,
        },
      });
      this.$map.MapInstance2D.addFlashMarket(flickerDrawPoint, this.layerId);
    },
    showTrajectory (val) {
      if (this.recordMarked) {
        this.$confirm(
          "当前有待下发任务的识别记录，您确定取消任务下发，切换至其他识别记录？",
          "取消任务下发",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.cancleMark(true);
          this.visibleDetail = false;
          this.visibleRight = true;
          this.main = true;
          this.nowMatchType = val.matchType;
          this.setSearch(val);
        });
      } else {
        this.recordMarked = false;
        this.visibleDetail = false;
        this.visibleRight = true;
        this.main = true;
        this.nowMatchType = val.matchType;
        this.setSearch(val);
      }
    },
    viewDetail (val) {
      console.log(val, "----viewrecord");
      this.isMark = false;
      this.markData = {};
      if (this.recordMarked) {
        this.$confirm(
          "当前有待下发任务的识别记录，您确定取消任务下发，切换至其他识别记录？",
          "取消任务下发",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.cancleMark(true);
          this.listDetailCilck(val);
          this.visibleRight = false;
          this.visibleDetail = true;
          this.detailInfo = val;
          this.nowMatchType = val.matchType;
        });
      } else {
        this.listDetailCilck(val);
        // 跳转到识别到的摄像机
        if (val.longitude && val.latitude) {
          let center = [Number(val.longitude), Number(val.latitude)];
          this.$map.MapInstance2D.setMapCenter(center);
        }
        this.recordMarked = false;
        this.visibleRight = false;
        this.visibleDetail = true;
        this.detailInfo = val;
        this.nowMatchType = val.matchType;
      }
    },
    setSearch (val) {
      this.nowMatchType = val.matchType;
      if (val.matchType === 1) {
        this.$refs.personSearch.imageUrl = val.fileCode
          ? this.imgPath(val)
          : "";
        this.$refs.personSearch.formData.fileList = val.fileCode
          ? [this.imgPath(val)]
          : [];
        this.$refs.personSearch.fileId = val.fileCode ? val.fileCode : "";
        this.$refs.personSearch.searchDataList = [];
      } else {
        this.$refs.carSearch.formListData.plateCode = val.plateNo;
        this.$refs.carSearch.searchDataList = [];
      }
    },
    imgPath (item) {
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    getPersonData (val) {
      this.$refs.trackInfo.personDataList = [].concat(val.personDataList);
      this.$refs.trackInfo.moreList = [].concat(val.moreList);
      this.$refs.trackInfo.nowPersonInfo = val.nowPersonInfo;
      this.$refs.trackInfo.getTrajectory(val.personDataList[0], "0");
    },
    getCarData (val) {
      this.$refs.carInfo.carDetailsList = val.carDetailsList;
      this.$refs.carInfo.moreList = [].concat(val.moreList);
    },
    showAll () {
      this.$router.push({ path: "/access/identifyRecord", query: { type: "all" } });
    },
    closeTree () {
      this.$refs["areaTree"].resetTreeData();
    },
    typeChange () {
      this.pageNum = 1;
      this.queryMatchRecord();
    },
    submitMark () {
      this.showTreeList = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.type-select {
  position: absolute;
  top: 40px;
  // bottom: 0;
  left: 0;
  width: 100px;
  overflow: hidden;
  height: 0;
  transition: all 0.2s;
  z-index: 101;
  .select-area {
    @include set_theme_color(background-color, input-disabled-bg-color);
    @include set_theme_color(border-color, active-border-color);
    border: 1px solid;
    // background-color: #fff;
    border-radius: 3px;
    height: 100px;
    width: 100%;
  }

  .type-option {
    padding: 0 10px;
    &.choosed {
      @include set_theme_color(background-color, page-tab-item-active-color);
      color: #ffffff;
    }
    &:hover {
      @include set_theme_color(background-color, page-tab-item-active-color);
      color: #ffffff;
      cursor: pointer;
    }
  }

  &.expand {
    height: 220px;
  }
}
</style>
<style lang="scss" >
@import "../style/IdentifyCenter.scss";
.el-select {
  width: 100%;
}
.icon-transform {
  transform: rotate(180deg);
  transition: all 0.2s;
}

.select-arrow {
  display: inline-block;
  transition: 0.2s;
  -moz-transition: 0.2s;
  /* Firefox 4 */
  -webkit-transition: 0.2s;
  /* Safari 和 Chrome */
  -o-transition: 0.2s;
  cursor: pointer;
}
</style>
